// extracted by mini-css-extract-plugin
export const section = "kandidatiVideo-module--section--1QjQn";
export const container = "kandidatiVideo-module--container--3b-5k";
export const pageContent = "kandidatiVideo-module--pageContent--2Dh_v";
export const footer = "kandidatiVideo-module--footer--2SKPC";
export const modal = "kandidatiVideo-module--modal--2CHT_";
export const pContainer = "kandidatiVideo-module--pContainer--1QW-S";
export const wrap = "kandidatiVideo-module--wrap--eqF-M";